module.exports = __webpack_public_path__ + "img/ic_xinyongka.32a364ef.png";